import React, { useRef } from 'react';
import './userregistration.scss';
import { AutoComplete, Checkbox, Input, ModalPopup, PrimaryButton, TreeviewDropdown } from '../CommonComponent';
import Alerts from '../Alerts';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import Loader from '../Loader';
import { Iprops } from './userregistrationinterface';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { Tooltip } from '@progress/kendo-react-tooltip';
import GetimageBaseURL, {
    facebooksvg,
    linkedinsvg,
    youtube,
    instagram,
    registration
} from "../../assets/images";

const UserRegistration = (props: Iprops) => {

    const imgUrl = GetimageBaseURL();
    const { errorSuccessMessage, isShowReqError, jobTitleList, stateOptions, onPopUpBtnClick, containerRef,
        distributorList, countryOptions, handleChange, handleDropdownChange, checkDistAvailabilityRes, notificationResponse,
        onCheckActivation, onSubmitForm, handleAlertClose, formData, errors, submitResponse, onClickLogin, onClose,
        onBlurZipCode, countryFromZipRes, showDistributorAvailabilityPopUp, handleDistAvailabilityPopup,
        modalNumberList, addressList, onChangeAddress, selectedAddress, handleChangeDistPopup, changeDistPopup, submitAlert, handleSubmitPopup,
        handleCloseConfirmation, closeConfirmation, onSocialMediaLogoClick, isKacApp
    } = props;

    const isDistributorDisabled = isKacApp ? !formData?.zip?.trim() : (!formData?.modalNumber || !formData?.zip?.trim());
    const isSerialNumberDisabled = (!isKacApp && !formData?.modalNumber);

    const getLabelClassName = (field: string) => {
        return `form-label ${errors?.[field] ? 'error-label' : ''}`;
    };
    
    const itemRender = (
        li: React.ReactElement<HTMLLIElement>,
        itemProps: any
    ) => {
        const itemChildren = (
            <div className="userRegistrationIconView">
                <div className='fa fa-map-marker location'></div>
                <div className='addressValue'>
                    <div> {itemProps?.dataItem?.addressLine}</div>
                    <div>
                        {
                            [
                                itemProps.dataItem?.locality,
                                itemProps.dataItem?.postalCode,
                                itemProps.dataItem?.adminDistrict2,
                                itemProps.dataItem?.adminDistrict,
                                itemProps.dataItem?.countryRegion
                            ]
                                .filter(Boolean)
                                .join(', ')
                        }
                    </div>
                </div>
            </div>
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    const firstFieldRef = useRef<any>(null);
    const backgroundUrl = `url(${imgUrl + registration})`;
    return (
        <div className='registration-wrapper'>
            <ToastContainer theme="colored" />
            {(notificationResponse?.loading || addressList?.loading || distributorList?.loading || jobTitleList?.loading || modalNumberList?.loading || stateOptions?.loading || countryOptions?.loading || submitResponse?.loading || countryFromZipRes?.loading || checkDistAvailabilityRes?.loading) && <Loader />}
            <div className='row'>
                <div className='col-lg-5'>
                    <div className='backgroundView' style={{ backgroundImage: backgroundUrl }}>
                        <div className='fleetContent'>
                            <div className='social-media-logo'>
                                <img src={imgUrl + facebooksvg} title="Facebook" alt='facebook' className="logo-image" onClick={onSocialMediaLogoClick} />
                                <img src={imgUrl + instagram} title="Instagram" alt='instagram' className="logo-image" onClick={onSocialMediaLogoClick} />
                                <img src={imgUrl + linkedinsvg} title="Linkedin" alt='linkedin' className="logo-image" onClick={onSocialMediaLogoClick} />
                                <img src={imgUrl + youtube} title="Youtube" alt='youtube' className="logo-image" onClick={onSocialMediaLogoClick} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-lg-7'>
                    <div className='userRegistrationView'>
                        <div className='Registraionheaderwrapper'>
                            <div className='registrationHeading'>Register now</div>
                            <div className='LoginapplyBtn' onClick={onClickLogin}>Login</div>
                        </div>
                        <div ref={containerRef} className='sessionscroll clearfix'>
                            {isShowReqError && <Alerts messageAlert={errorSuccessMessage} alertType={'error'} onClose={handleAlertClose} />}
                            <div className='sessionregistration'>
                                <div className='RegistrationSubHeading'>Personal information</div>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('firstName')}>First name<sup>*</sup></label>
                                            <input autoComplete='none' ref={firstFieldRef} type='text' name="firstName" value={formData?.firstName} onChange={handleChange} className="registerDropdown firstNameDD" tabIndex={1} />
                                        </div>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('email')}>Email address<sup>*</sup></label>
                                            <Input placeholder="e.g. myname@example.net" type='text' name="email" className="registerDropdown" value={formData?.email} onChange={handleChange} tabIndex="3" />
                                            {submitResponse?.data?.userExists && <div className='mt-2 blueTextEmail'>{'Email already exists. Please'} <a className='clickHyperlink' onClick={onClickLogin}>{'click here'}</a> {'to login'}</div>}
                                        </div>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('jobTitle')}>Job title (choose the best title that describes you)<sup>*</sup></label>
                                            <TreeviewDropdown
                                                placeholder='Select'
                                                treeData={jobTitleList?.data || []}
                                                showSearch={true}
                                                dropdownClassName={'dropdownListContainer noNested'}
                                                className={'multislectDropdown registerDropdown'}
                                                value={formData?.jobTitle || null}
                                                tabIndex={5}
                                                onChange={(value: any, _: any, extra: any) => handleDropdownChange('jobTitle', value, extra?.triggerNode?.props)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('lastName')}>Last name<sup>*</sup></label>
                                            <Input type='text' name="lastName" value={formData?.lastName} onChange={handleChange} className="registerDropdown" tabIndex="2" />
                                        </div>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('phoneNumber')}>Phone number<sup>*</sup></label>
                                            <MaskedTextBox
                                                value={formData?.phoneNumber === '(___) ___-____' ? '' : formData?.phoneNumber}
                                                onChange={(e: any) => handleDropdownChange('phoneNumber', e?.target?.value, '')}
                                                mask="(999) 000-0000"
                                                placeholder={"(___) ___-____"}
                                                className='phnumberinputRegister registerDropdown'
                                                tabIndex={4}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='sessionregistration'>
                                <div className='RegistrationSubHeading'>Company information</div>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('companyName')}>Company name<sup>*</sup></label>
                                            <Input type='text' name="companyName" value={formData?.companyName} onChange={handleChange} className="registerDropdown" tabIndex="6" />
                                        </div>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('city')}>City<sup>*</sup></label>
                                            <Input type='text' name="city" value={formData?.city} onChange={handleChange} className="registerDropdown" tabIndex="8" />
                                        </div>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('zip')}>ZIP<sup>*</sup></label>
                                            <Input type='text' name="zip" value={formData?.zip} onChange={handleChange} className="registerDropdown" onBlur={onBlurZipCode} tabIndex="11" />
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('address')}>Address<sup>*</sup></label>
                                            <AutoComplete
                                                textField={'addressLine'}
                                                selectedValue={selectedAddress}
                                                className='addressAutoComplete'
                                                itemRender={itemRender}
                                                name="address"
                                                data={addressList?.data || []}
                                                onChange={onChangeAddress}
                                                value={formData?.address}
                                                onClose={props?.onCloseAddress}
                                                onFocus={props?.onFocusAddress}
                                                tabIndex="7"
                                                onBlur={props?.onBlurAddress} />
                                        </div>
                                        <div className='form-group'>
                                            <div className=''>
                                                <div className='row'>
                                                    <div className='col-lg-6 col-12'>
                                                        <div className="mr-2">
                                                            <label className={getLabelClassName('state')}>State / Province<sup>*</sup></label>
                                                            <TreeviewDropdown
                                                                placeholder='Select'
                                                                treeData={stateOptions?.data || []}
                                                                showSearch={true}
                                                                dropdownClassName={'dropdownListContainer noNested'}
                                                                className={'multislectDropdown registerDropdown'}
                                                                value={formData?.state || null}
                                                                tabIndex="9"
                                                                onChange={(value: any, _: any, extra: any) => handleDropdownChange('state', value, extra?.triggerNode?.props)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-6 col-12'>
                                                        <div>
                                                            <label className={getLabelClassName('country')}>Country<sup>*</sup></label>
                                                            <TreeviewDropdown
                                                                placeholder='Select'
                                                                treeData={countryOptions?.data || []}
                                                                showSearch={true}
                                                                dropdownClassName={'dropdownListContainer noNested'}
                                                                className={'multislectDropdown registerDropdown'}
                                                                value={formData?.country || null}
                                                                tabIndex="10"
                                                                onChange={(value: any, _: any, extra: any) => handleDropdownChange('country', value, extra?.triggerNode?.props)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='sessionregistration'>
                                <div className='RegistrationSubHeading'>Fleet information</div>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='form-group'>
                                            <div className='label-with-tooltip'>
                                                <label className={getLabelClassName('modalNumber')}>Model{!isKacApp && <sup>*</sup>}<Tooltip anchorElement="target" position="bottom" className='infoToolTip' >
                                                    <span className='k-icon k-i-info infoIcon' title='Please enter the model number from one machine in your fleet'></span>
                                                </Tooltip></label>
                                            </div>
                                            <TreeviewDropdown
                                                placeholder='Select'
                                                treeData={modalNumberList?.data || []}
                                                showSearch={true}
                                                dropdownClassName={'dropdownListContainer noNested'}
                                                className={'multislectDropdown registerDropdown'}
                                                value={formData?.modalNumber || null}
                                                filterTreeNode={(input: any, node: any) => {
                                                    return input.length >= 3
                                                        ? node?.title?.toLowerCase().includes(input?.toString().toLowerCase())
                                                        : true;
                                                }}
                                                treeDefaultExpandAll
                                                treeNodeFilterProp={'value'}  
                                                tabIndex='12'
                                                allowClear={true}
                                                onChange={(value: any, _: any, extra: any) => handleDropdownChange('modalNumber', extra?.triggerNode?.props?.name, extra?.triggerNode?.props)}
                                            />
                                        </div>
                                        <div className='form-group'>
                                            <label className={getLabelClassName('distributor')}>Distributor<sup>*</sup></label>
                                            <TreeviewDropdown
                                                placeholder='Select'
                                                treeData={distributorList?.data || []}
                                                showSearch={true}
                                                disabled={isDistributorDisabled}
                                                dropdownClassName={'dropdownListContainer noNested'}
                                                className={'multislectDropdown registerDropdown'}
                                                value={formData?.distributor || null}
                                                tabIndex='14'
                                                onChange={(value: any, _: any, extra: any) => handleDropdownChange('distributor', value, extra?.triggerNode?.props)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className='form-group'>
                                            <div className='label-with-tooltip'>
                                                <label className={getLabelClassName('serialNumber')}> Serial number{!isKacApp && <sup>*</sup>}<Tooltip anchorElement="target" position="bottom" className='infoToolTip'>
                                                    <span className='k-icon k-i-info infoIcon' title='Please enter the serial number from one machine in your fleet'></span>
                                                </Tooltip></label>

                                            </div>
                                            <Input tabIndex='13'
                                                disabled={isSerialNumberDisabled} type='text' name="serialNumber" value={formData?.serialNumber} onChange={handleChange} className="registerDropdown" />
                                        </div>
                                    </div>
                                </div>
                                <div className='infoView'><span className='k-icon k-i-info'></span>Please check your email/text for the invitation and follow up to complete your registration.</div>
                                <div className='actionItem'><span className='mr-2'>
                                    <Checkbox tabIndex={-1} checked={formData?.isAgreeTerms} onChange={(e: any) => handleDropdownChange('isAgreeTerms', e?.target?.checked)} /></span><span tabIndex={15} className='checkboxUser termsAgree' onKeyDown={(event: any) => {
                                        if (event.key === 'Enter') {
                                            props?.onTermsClick();
                                        }
                                    }} onClick={() => { props?.onTermsClick(); handleDropdownChange('isAgreeTerms', !formData?.isAgreeTerms) }}>I agree to the terms of use</span><sup>*</sup></div>
                                <div className='actionItem'><span className='mr-2'><Checkbox tabIndex={-1} checked={formData?.isSendInvitation} onChange={(e: any) => handleDropdownChange('isSendInvitation', e?.target?.checked)} /></span><span className='checkboxUser' onClick={() => { handleDropdownChange('isSendInvitation', !formData?.isSendInvitation) }}> Send invitation as text (message and data rates may apply) </span></div>
                            </div>
                        </div>
                        <div className='footerView mt-5'>
                            <div className="footerbtn">
                                <PrimaryButton tabIndex={16} text="Close" title="Close" className="applyBtn " onClick={onClose} />
                                <PrimaryButton tabIndex='17' text='Check activation' title={'Check activation'} className="applyBtn mx-2" onClick={onCheckActivation} />
                                <PrimaryButton tabIndex={18} text="Submit" title="Submit" className="applyBtn " onClick={onSubmitForm} />
                            </div>
                        </div>

                        {
                            showDistributorAvailabilityPopUp && (
                                <ModalPopup
                                    ModalPopupTitle={"Information"}
                                    ShowModalPopupFooter={true}
                                    ModalPopupType="smaller"
                                    closeModalPopup={() => handleDistAvailabilityPopup(false)}
                                    FooterPrimaryBtnTxt={"Ok"}
                                    PrimaryBtnOnclick={() => handleDistAvailabilityPopup(false)}
                                    ModalPopupName="distributor-availability-popup"
                                >
                                    <div>
                                        <div className='mb-2'>We're sorry but the Komatsu distributor servicing this area has not yet been configured to receive and process Komatsu Genuine Parts orders via MyKomatsu.</div>

                                        <div className='mb-2'>We do expect to begin offering this functionality in your area in the very near future.</div>

                                        <div>In the meantime, please contact your local Komatsu distributor directly for all of your Komatsu Genuine Parts needs!</div>
                                    </div>
                                </ModalPopup>
                            )
                        }
                        {
                            changeDistPopup && (
                                <ModalPopup
                                    ModalPopupTitle={""}
                                    ShowModalPopupFooter={true}
                                    ModalPopupType="smaller"
                                    closeModalPopup={() => handleChangeDistPopup(false)}
                                    FooterPrimaryBtnTxt={"NO"}
                                    FooterSecondaryBtnTxt={"YES"}
                                    PrimaryBtnOnclick={() => onPopUpBtnClick(false)}
                                    SecondryBtnOnclick={() => onPopUpBtnClick(true)}
                                    ModalPopupName="distributor-availability-popup"
                                >
                                    <div>
                                        <div>Based on your zipcode, your servicing distributor is selected, are you sure you want to change the distributor?</div>
                                    </div>
                                </ModalPopup>
                            )
                        }
                        {
                            submitAlert && (
                                <ModalPopup
                                    ModalPopupTitle={"Registration Completed Successfully"}
                                    ShowModalPopupFooter={true}
                                    ModalPopupType="small"
                                    FooterPrimaryBtnTxt={"Ok"}
                                    PrimaryBtnOnclick={() => handleSubmitPopup(false, true)}
                                    ModalPopupName="Register-User-popup"
                                >
                                    <div className='Registeruserpopup'>
                                        <div className="value">Thank you for registering on My Komatsu.</div>
                                        <div className="value">Distributor has been notified and will get back to you.</div>
                                        <div className="value companyValue">{submitResponse?.data?.distributorName}</div>
                                        <div className="value wraptext">Email: {submitResponse?.data?.distributorEMails || ' - '}</div>
                                    </div>
                                </ModalPopup>
                            )
                        }
                        {
                            closeConfirmation && (
                                <ModalPopup
                                    ModalPopupTitle={""}
                                    ShowModalPopupFooter={true}
                                    ModalPopupType="smaller"
                                    closeModalPopup={() => handleCloseConfirmation(false)}
                                    FooterPrimaryBtnTxt={"NO"}
                                    FooterSecondaryBtnTxt={"YES"}
                                    PrimaryBtnOnclick={() => handleCloseConfirmation(false)}
                                    SecondryBtnOnclick={() => handleCloseConfirmation(true)}
                                    ModalPopupName="distributor-availability-popup"
                                >
                                    <div>
                                        <div>Are you sure, you want to cancel this registration?</div>
                                    </div>
                                </ModalPopup>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserRegistration;